import { SendEmailMessage } from 'sections/onsite-campaigns/types';
import { SendEmailAction, SendEmailState } from './SendEmailState';
import { CampaignMessage } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';

const assign = (state: SendEmailState, id: string, property: Partial<SendEmailMessage>) => {
  const message: SendEmailMessage = {
    ...(state[id] ?? ({} as any)),
    messageType: 'offsite',
    ...property,
  };

  return { ...state, [id]: message } as { [key: string]: CampaignMessage<SendEmailMessage> };
};

export const SendEmailReducer = (state: SendEmailState, action: SendEmailAction) => {
  switch (action.type) {
    case 'ADD_SEND_EMAIL': {
      const { id, segmentId, onsiteSegmentId } = action.payload;

      const messageCount =
        Object.keys(state)
          .map(k => state[k])
          .filter(s => s.messageType === 'offsite').length + 1;
      const defaultName = `Email #${messageCount}`;

      return assign(state, id, { id, segmentId, onsiteSegmentId, name: defaultName });
    }

    case 'UPDATE_SEND_EMAIL_NAME': {
      const { id, name } = action.payload;

      return assign(state, id, {
        name: name,
      });
    }
    case 'REMOVE_SEND_EMAIL_MESSAGE': {
      const newState = { ...state };
      delete newState[action.payload.id];

      return newState;
    }
    case 'SET_SELECTED_SUBJECT_LINE': {
      const { id, subjectLineId, subjectLineLabel } = action.payload;

      return assign(state, id, { subjectLine: { id: subjectLineId, label: subjectLineLabel } });
    }
    case 'SET_SEND_EMAIL_TEMPLATE': {
      const { id, templateId, templateName, supportedLanguage, templateType, isEmbedded } = action.payload;

      return assign(state, id, {
        template: { id: templateId, name: templateName, supportedLanguage, type: templateType, isEmbedded },
      });
    }
    case 'LINK_SEND_EMAIL_TO_DISPLAY_WEB_CONTENT': {
      const { id, onsiteSegmentId } = action.payload;

      return assign(state, id, {
        onsiteSegmentId: onsiteSegmentId,
      });
    }
    default:
      return state;
  }
};
